import { combineReducers } from 'redux'

// ACTIONS
export const CREATE = 'offerzen/uploadedFiles/CREATE'
export const CREATE_SUCCESS = 'offerzen/uploadedFiles/CREATE_SUCCESS'

export const FETCH = 'offerzen/uploadedFiles/FETCH'
export const FETCH_SUCCESS = 'offerzen/uploadedFiles/FETCH_SUCCESS'

export const DELETE = 'offerzen/uploadedFiles/DELETE'

// CREATE CREATORS
export const createUploadedFiles = (id, data) => ({
  type: CREATE,
  payload: { id, data },
})

export const createUploadedFileSuccess = data => ({
  type: CREATE_SUCCESS,
  payload: { ...data },
})

export const fetchUploadedFiles = id => ({
  type: FETCH,
  payload: { id },
})

export const fetchUploadedFilesSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const deleteUploadedFiles = (id, candidate_id) => ({
  type: DELETE,
  payload: { id, candidate_id },
})

// REDUCERS
const uploadedFile = (state = {}, action) => {
  switch (action.type) {
    case CREATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

const entities = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      const nextState = { ...state }
      action.payload.forEach(file => (nextState[file.id] = file))
      return nextState

    case CREATE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: uploadedFile(state[action.payload.id], action),
      }

    default:
      return state
  }
}

const byId = (state = [], action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      return action.payload.map(file => file.id)

    case CREATE_SUCCESS:
      return [...state, action.payload.id]

    default:
      return state
  }
}

const uploadedFilesReducer = combineReducers({
  entities,
  ids: byId,
})

export default uploadedFilesReducer
